import {EquipmentSearchInputQuery_equipment_EquipmentNode as EquipmentNode} from './__generated/EquipmentSearchInputQuery';

// keep in sync with benchling/instruments/equipment/domain/schema_configuration/constants.py
export const EQUIPMENT_SCHEMA_INTERFACE_ID = 'ssi_equipment';

export const MODEL_FIELD_SYSTEM_NAME = 'model';
export const MODEL_FIELD_DISPLAY_NAME = 'Model';

export type Equipment = EquipmentNode;
